// extracted by mini-css-extract-plugin
module.exports = {"page":"RegisterPage_page__3Nri9","card":"RegisterPage_card__1ntWu","title":"RegisterPage_title__2JwYr","form":"RegisterPage_form__VTpk7","foot":"RegisterPage_foot__2vmoy"};